import { gql } from '@apollo/client';

import { ICashOrder } from 'types';

export interface IGetWorkShiftSummaryResponse {
  getWorkShiftPaymentOverviewData: {
    total: number;
    cash_on_start: number;
    cash: number;
    card: number;
    cash_orders: Array<Pick<ICashOrder, 'sum' | 'type'>>;
  } | null;
}
export interface IGetWorkShiftSummaryRequest {
  id?: number;
}
export const GET_WORKSHIFT_SUMMARY = gql`
  query getWorkShiftPaymentOverviewData($id: Int) {
    getWorkShiftPaymentOverviewData(id: $id) {
      total
      cash_on_start
      cash
      card
      cash_orders {
        type
        sum
      }
    }
  }
`;
